import { createSelector } from 'reselect';
import YearlyThresholdsColumns from '../../containers/YearlyThresholdsColumns';
import TableDefinitions from '../../../../common/TableDefinitions';

export const getIsLoading = (state) => state.listing.YEARLY_THRESHOLDS_PAGE.isLoading;
export const getCheckedRows = (state) => state.listing.YEARLY_THRESHOLDS_PAGE.selectedRows;
export const getData = TableDefinitions.YEARLY_THRESHOLDS_PAGE.getDataFunction();
export const getColumns = createSelector(
  getData,
  (state) => state.userData.userInfo[0].split('_'),
  YearlyThresholdsColumns,
);

export const getSelectedOperatorOnTable = (state) => state.left.selectedOperator;
export const getSelectedImpcOnTable = (state) => state.left.selectedImpc;
